import { render, staticRenderFns } from "./CustomerPaymentLink.vue?vue&type=template&id=5b815ffe&"
import script from "./CustomerPaymentLink.vue?vue&type=script&lang=js&"
export * from "./CustomerPaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports